// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoHubGetPatientWelcomeSummaryResponse {
    'patientFirstName': string;
    'isVerified': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoHubGetPatientWelcomeSummaryResponse>> = [
        {
            "name":     "patientFirstName",
            "baseName": "patientFirstName",
            "type":     "string"
        },
        {
            "name":     "isVerified",
            "baseName": "isVerified",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return MangoHubGetPatientWelcomeSummaryResponse.attributeTypeMap;
    }
}
